import ActiveSchoolList from './ActiveSchoolList'
export default ActiveSchoolList